import React from 'react';
import {GetBioBankInfo, GetIdentifier, GetSequencingInfo, GetStatus} from "./GetSections";
import Box from '@mui/material/Box';
import GetJSXList from "./GetJSXList";
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import ReactJson from 'react-json-view';
import "../experiment-info.css"




// Browse Button to go back or to Phenostore
const ExperimentInformationMainFrame = (props) => {
    return (
        <Box m={2}>
            <div className="borderExperiment">
                <Grid container>
                    {/* Experiment Dates */}
                    <Grid item lg={12}>
                        <Box p={2}>
                            <div> <div className={"field_key"}> Load Date:</div> {props.ExperimentInformation.LOADDATE} </div>
                            <div> <div className={"field_key"}>Postembargo Date:</div>  {props.ExperimentInformation.POSTEMBARGODATE}</div>
                        </Box>
                    </Grid>
                    {/* Identifier */}
                    <GetIdentifier ExperimentInformation={props.ExperimentInformation}/>
                    {/* EGA / Biobank Information */}
                    <Divider/>
                    <GetBioBankInfo ExperimentInformation={props.ExperimentInformation}/>
                    {/* Sequencing Information */}
                    <Divider/>
                    <GetSequencingInfo ExperimentInformation={props.ExperimentInformation}/>
                    {/* Status */}
                    <Divider/>
                    <GetStatus ExperimentInformation={props.ExperimentInformation}/>
                    {/* Projects */}
                    <Divider/>
                    <Grid item lg={12}>
                        <Typography variant={"h6"} > PROJECTS</Typography>
                    </Grid>
                    <Grid item lg={12}>
                        <Box p={2}>
                            <ul> 
                                <GetJSXList values={props.ExperimentInformation.projects}/> 
                            </ul>
                        </Box>
                    </Grid>
                    {/* ERNs */}
                    <Divider/>
                    <Grid item lg={12}>
                        <Typography variant={"h6"} > ERNs</Typography>
                    </Grid>
                    <Grid item lg={12}>
                        <Box p={2}>
                            { props.ExperimentInformation.erns ? props.ExperimentInformation.erns : "None" }
                        </Box>
                    </Grid>
                    {/* Analysis Pipeline */}
                    { props.ExperimentInformation.pipeline ?
                        <div>
                            <Grid item lg={12}>
                                <Typography variant={"h6"} > ANALYSIS PIPELINE </Typography>
                            </Grid>
                            <Grid item lg={12}>
                                <ReactJson  src={props.ExperimentInformation.pipeline[1]} 
                                            name={props.ExperimentInformation.pipeline[0]}
                                            displayDataTypes={false}
                                            iconStyle="circle"
                                            theme="summerfruit:inverted"
                                            displayObjectSize={false}
                                />
                            </Grid>
                        </div>
                        :   
                        <div></div>
                    } 
                </Grid>
            </div>
        </Box>
    );           
}

export default ExperimentInformationMainFrame;